const JS_HOOK_MESSAGE = '[js-hook-message]'
const JS_HOOK_CLOSE_BTN = '[js-hook-alert-close]'

const removeAlertMessage = function (hook) {
  const selector = hook || JS_HOOK_MESSAGE
  const errorEl = document.querySelector(selector)
  if (!errorEl) return
  errorEl.classList.add('u-hidden')
  errorEl.setAttribute('aria-hidden', true)

  const closeButton = errorEl.querySelector(JS_HOOK_CLOSE_BTN)
  if (closeButton) {
    closeButton.setAttribute('tabindex', -1)
  }
}
export default removeAlertMessage
